import "core-js/modules/web.dom-collections.iterator.js";
import { useState, useEffect } from "react";

// https://gist.github.com/gragland/b61b8f46114edbcf2a9e4bd5eb9f47f5
export function useKeyPress(targetKey) {
  let onPressDown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  let onPressUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);
  useEffect(() => {
    // If pressed key is our target key then set to true
    function downHandler(_ref) {
      let {
        key
      } = _ref;
      if (key === targetKey) {
        setKeyPressed(true);
        onPressDown();
      }
    }

    // If released key is our target key then set to false
    const upHandler = _ref2 => {
      let {
        key
      } = _ref2;
      if (key === targetKey) {
        setKeyPressed(false);
        onPressUp();
      }
    };

    // Add event listeners
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);

    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  });
  return keyPressed;
}